import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

// Services
import { getManagerAccessToken } from '../services/auth/authService';

// Components
import Page from '../components/templates/Page/Page';

/**
 * TokenApi component.
 * @returns {JSX.Element}
 */
function TokenApi() {
  const [searchParams] = useSearchParams();

  const handleGetManagerAccessToken = () => {
    const apiKey = searchParams?.get('apiKey');
    const path = searchParams?.get('path');

    if (!apiKey) {
      window.location.replace(import.meta.env.VITE_TOKEN_REDIRECT_URL + (path ? `?path=${path}` : ''));
    }

    getManagerAccessToken(apiKey).then(() => {
      window.location.replace(path || '/');
    });
  };

  useEffect(() => {
    handleGetManagerAccessToken();
  }, []);

  return (
    <Page page={{ template: 'timeline', path: '', format: null }} />
  );
}

export default TokenApi;
